<template>
  <div class="container waterman20">
    <div class="row">
        <div class="col-lg-12 text-right" style="margin-bottom:15px;">
            <router-link class="btn btn-purple" to="/interviewWaterman20">Интервью участников проекта</router-link>
        </div>
        <div class="col-lg-12">
            <h1 class="text-center">{{ title }}</h1>
                <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                    <div class="carousel-inner">
                        <div v-for="(award, index) in awarded" :key="award.id" v-bind:class="['carousel-item', index == activeSlide ? 'active' : '']">
                        <!-- <img class="d-block w-100" src='./../../assets/img/waterman20/carousel/'> -->
                        <img class="d-block w-100" :src="'/static/img/waterman20/carousel/' + award.img + '.jpg'" :alt="award.title">
                        <div class="carousel-caption text-right">
                            <h4>{{ award.title }}</h4>
                        </div>
                        </div>
                    </div>
                    <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Предыдущий</span>
                    </a>
                    <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Следующий</span>
                    </a>
                </div>
            <table class="table table-hover">
                <thead class="thead-dark text-center">
                    <tr>
                    <th scope="col">НОМЕР ЗНАКА</th>
                    <th scope="col">НАГРАЖДАЕМЫЙ</th>
                    <th scope="col">СТАТУС</th>
                    </tr>
                </thead>
                <tbody>
                    <tr><th scope="row">1</th><td>Леонов Геннадий<br>(1994 — 2005) директор МУП «Водоканал»<br>(2005 — 2006) директор ОАО «ОмскВодоканал»<br></td><td>Вручен</td></tr>
                    <tr><th scope="row">2</th><td>Шелест Сергей<br>(2014 — 2022) генеральный директор ОАО «ОмскВодоканал»</td><td>Вручен</td></tr>
                    <tr><th scope="row">3</th><td>Смиковская Ольга<br>(2006 — н.в.) коммерческий директор ОАО «ОмскВодоканал»</td><td>Вручен</td></tr>
                    <tr><th scope="row">4</th><td>Рогачев Сергей<br>(2010 — 2021) начальник отдела ИТ ОАО «ОмскВодоканал»</td><td>Вручен</td></tr>
                    <tr><th scope="row">5</th><td>Хоменко Ирина<br>(1997 — 2003) технолог и инженер-программист<br>(2003 — н.в.) руководитель группы сопровождения ПО</td><td>Вручен</td></tr>
                    <tr><th scope="row">6</th><td>Насибуллина Марианна<br>(2007 — н.в.) инженер-программист ООО «ХардСофт321»</td><td>Вручен</td></tr>
                    <tr><th scope="row">7</th><td>Гусынин Евгений<br>(2011 — н.в.) инженер-программист ООО «ХардСофт321»</td><td>Вручен</td></tr>
                    <tr><th scope="row">8</th><td>Наконечный Владислав<br>2008 — н.в.) инженер-программист ООО «ХардСофт321»</td><td>Вручен</td></tr>
                    <tr><th scope="row">9</th><td>Погребицкая Ольга<br>(2007 — 2013) инженер коммерческой дирекции<br>(2013 — н.в.) ведущий технолог/аналитик</td><td>Вручен</td></tr>
                    <tr><th scope="row">10</th><td>Чебоксаров Сергей<br>(1998 — н.в.) заместитель директора ООО «Лаборатория Систем 321»</td><td>Вручен</td></tr>
                    <tr><th scope="row">11</th><td>Лихачева Лариса<br>(2006 — 2015) инженер претензионно договорного отдела<br>(2015 — н.в.) ведущий специалист отдела по заключению договоров</td><td>Вручен</td></tr>
                    <tr><th scope="row">12</th><td>Квашнина Светлана</td><td>Вручен</td></tr>
                    <tr><th scope="row">13</th><td>Рахимжанов Тимур</td><td>Вручен</td></tr>
                    <tr><th scope="row">15</th><td>Посников Игорь</td><td>Вручен</td></tr>
                    <tr><th scope="row"></th><td>Страхов Константин</td><td>Ждет</td></tr>
                    <tr><th scope="row">17</th><td>Беликов Сергей</td><td>Вручен</td></tr>
                    <tr><th scope="row"></th><td>Краснобородкин Сергей</td><td>Ждет</td></tr>
                    <tr><th scope="row"></th><td>Ефремов Никита</td><td>Ждет</td></tr>
                    <tr><th scope="row">20</th><td>Никитин Лев</td><td>Вручен</td></tr>
                    <tr><th scope="row">21</th><td>Шульман Глеб (Shulman Gleb)</td><td>Вручен</td></tr>
                    <tr><th scope="row">22</th><td>Морозова Татьяна (Hepplewhite Tatiana)</td><td>Вручен</td></tr>
                    <tr><th scope="row">23</th><td>Корякова Елена</td><td>Вручен</td></tr>
                    <tr><th scope="row">24</th><td>Буш Светлана (Busch Swetlana)</td><td>Вручен</td></tr>
                    <tr><th scope="row">25</th><td>Буш Сергей (Busch Sergej)</td><td>Вручен</td></tr>
                </tbody>
            </table>
        </div>
        <div class="col-lg-12">
            <img src="/static/img/waterman20/waterman20.jpg" class="img-fluid mx-auto d-block mb-3" alt="Waterman 20 лет">
        </div>
        <div class="col-lg-12 text-left" style="margin-top:15px;">
            <router-link class="btn btn-purple" to="/interviewWaterman20">Интервью участников проекта</router-link>
        </div>
    </div>
  </div>
</template>

<script>
var awarded = [
    {title: "Значoк №01 Леонов Геннадий", img: "w01-001"},
    {title: "Значoк №01 Леонов Геннадий", img: "w01-002"},

    {title: "Значoк №02 Шелест Сергей", img: "w02-001"},
    {title: "Значoк №02 Шелест Сергей", img: "w02-002"},
    {title: "Значoк №02 Шелест Сергей", img: "w02-003"},

    {title: "Значoк №03 Смиковская Ольга", img: "w03-001"},
    {title: "Значoк №03 Смиковская Ольга", img: "w03-002"},
    {title: "Значoк №03 Смиковская Ольга", img: "w03-003"},

    {title: "Значoк №04 Рогачев Сергей", img: "w04-001"},
    {title: "Значoк №04 Рогачев Сергей", img: "w04-002"},
    {title: "Значoк №04 Рогачев Сергей", img: "w04-003"},

    {title: "Значoк №05 Хоменко Ирина", img: "w05-001"},
    {title: "Значoк №05 Хоменко Ирина", img: "w05-002"},
    {title: "Значoк №05 Хоменко Ирина", img: "w05-003"},

    {title: "Значoк №06 Насибуллина Марианна", img: "w06-001"},
    {title: "Значoк №06 Насибуллина Марианна", img: "w06-002"},
    {title: "Значoк №06 Насибуллина Марианна", img: "w06-003"},

    {title: "Значoк №07 Гусынин Евгений", img: "w07-001"},
    {title: "Значoк №07 Гусынин Евгений", img: "w07-002"},
    {title: "Значoк №07 Гусынин Евгений", img: "w07-003"},

    {title: "Значoк №08 Наконечный Владислав", img: "w08-001"},
    {title: "Значoк №08 Наконечный Владислав", img: "w08-002"},
    {title: "Значoк №08 Наконечный Владислав", img: "w08-003"},

    {title: "Значoк №09 Погребицкая Ольга", img: "w09-001"},
    {title: "Значoк №09 Погребицкая Ольга", img: "w09-002"},
    {title: "Значoк №09 Погребицкая Ольга", img: "w09-003"},

    {title: "Значoк №10 Чебоксаров Сергей", img: "w10-001"},
    {title: "Значoк №10 Чебоксаров Сергей", img: "w10-002"},
    {title: "Значoк №10 Чебоксаров Сергей", img: "w10-003"},

    {title: "Значoк №11 Лихачева Лариса", img: "w11-001"},
    {title: "Значoк №11 Лихачева Лариса", img: "w11-002"},
    {title: "Значoк №11 Лихачева Лариса", img: "w11-003"},

    {title: "Значoк №12 Квашнина Светлана", img: "w12-001"},
    {title: "Значoк №12 Квашнина Светлана", img: "w12-002"},
    {title: "Значoк №12 Квашнина Светлана", img: "w12-003"},

    {title: "Значoк №13 Рахимжанов Тимур", img: "w13-001"},

    {title: "Значoк №15 Посников Игорь", img: "w15-001"},
    {title: "Значoк №15 Посников Игорь", img: "w15-002"},
    {title: "Значoк №15 Посников Игорь", img: "w15-003"},

    {title: "Значoк №17 Беликов Сергей", img: "w17-001"},
    {title: "Значoк №17 Беликов Сергей", img: "w17-002"},
    {title: "Значoк №17 Беликов Сергей", img: "w17-003"},

    {title: "Значoк №20 Никитин Лев", img: "w20-001"},

    {title: "Значoк №21 Шульман Глеб (Shulman Gleb)", img: "w21-001"},

    {title: "Значoк №22 Морозова Татьяна (Hepplewhite Tatiana)", img: "w22-001"},

    {title: "Значoк №23 Корякова Елена, Значoк №24 Буш Светлана", img: "w23-w24-001"},

    {title: "Значoк №25 Буш Сергей", img: "w24-001"},
    {title: "Значoк №25 Буш Сергей", img: "w24-002"},
    {title: "Значoк №25 Буш Сергей", img: "w24-003"},
            ];
export default {
    name: 'Waterman20',
    data () {
        return {
            message: '',
            activeSlide : this.getRandomInt(),
            title: 'WATERMAN 20 Лет',
            awarded: awarded
        }
    },
    methods: {
        getRandomInt (min, max) {
            if (typeof awarded != undefined) {
                var min = 0;
                var max = awarded.length;
                return Math.floor(Math.random() * (max - min)) + min;
            } else {
                return 1;
            }
        }
    }
}
</script>

<style scoped>
  .container {
    margin-top: 115px;
  }
  .table td {
    vertical-align: middle;
  }
  .table th {
    text-align: center;
  }
  .table td, .table th {
    padding: 0.35rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Waterman20.vue